import React from 'react';
import styled from 'styled-components';
import Title from '../../Components/Text/Title';

import partner_img1 from '../../Images/partner_img1.png';
import partner_img2 from '../../Images/partner_img2.png';
import partner_img3 from '../../Images/partner_img3.png';
import partner_img4 from '../../Images/partner_img4.jpg';
import partner_img5 from '../../Images/partner_img5.png';
import partner_img6 from '../../Images/partner_img6.jpg';
import partner_img7 from '../../Images/partner_img7.png';
import partner_img8 from '../../Images/partner_img8.png';
import partner_img9 from '../../Images/partner_img9.png';
import partner_img10 from '../../Images/partner_img10.png';
import partner_img11 from '../../Images/partner_img11.jpg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding-top: 180px;
  padding-bottom: 280px;
`
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 970px;
  position: relative;
  z-index: 10;
  justify-content: center;
  align-items: center;
  @media (max-width: 1010px) {
    width: 100%;
    padding: 0 20px;
  };
`
const ContentsContainer = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-around;
  width: 100%;
  flex-wrap: wrap;
  & > div {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    height: 120px;
    & > img {
      width: 90%;
      max-width: 180px;
      object-fit: contain;
    }
  }
`

const PartnersContainer = () => {
  return (
    <Container>
      <SubContainer>
        <Title
          text={'Partners'}
        />
        <ContentsContainer>
          <div onClick={() => {
            window.open('http://gripfan.co.kr/')
          }}>
            <img alt="" src={partner_img1} />
          </div>
          <div onClick={() => {
            window.open('http://pigbox.co.kr/')
          }}>
            <img alt="" src={partner_img2} />
          </div>
        </ContentsContainer>
        <ContentsContainer style={{ marginTop: 0 }}>
        <div onClick={() => {}}>
            <img alt="" src={partner_img3} />
          </div>
          <div onClick={() => {}}>
            <img alt="" src={partner_img4} />
          </div>
          <div onClick={() => {}}>
            <img alt="" src={partner_img5} />
          </div>
          <div onClick={() => {}}>
            <img alt="" src={partner_img6} />
          </div>
          <div onClick={() => {}}>
            <img alt="" src={partner_img7} />
          </div>
          <div onClick={() => {}}>
            <img alt="" src={partner_img8} />
          </div>
          <div onClick={() => {}}>
            <img alt="" src={partner_img9} />
          </div>
          <div onClick={() => {}}>
            <img alt="" src={partner_img10} />
          </div>
          <div onClick={() => {}}>
            <img alt="" src={partner_img11} style={{ maxWidth: 70 }}/>
          </div>
        </ContentsContainer>
      </SubContainer>
    </Container>
  )
}

export default PartnersContainer;